import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
    interface Window {
        Pusher: typeof Pusher;
        Echo?: Echo<'reverb'>;
    }
}

window.Pusher = Pusher;

let instance: Echo<'reverb'> | null = null;

export function getEcho(): Echo<'reverb'> {
    if (instance) return instance;

    const scheme = (import.meta.env.VITE_REVERB_SCHEME as string | undefined) ?? 'http';
    const host = (import.meta.env.VITE_REVERB_HOST as string | undefined) ?? window.location.hostname;
    const port = Number(import.meta.env.VITE_REVERB_PORT ?? 8080);

    instance = new Echo({
        broadcaster: 'reverb',
        key: import.meta.env.VITE_REVERB_APP_KEY as string,
        wsHost: host,
        wsPort: port,
        wssPort: port,
        forceTLS: scheme === 'https',
        enabledTransports: ['ws', 'wss'],
        authEndpoint: '/broadcasting/auth',
    });

    window.Echo = instance;
    return instance;
}

export function disconnectEcho(): void {
    if (!instance) return;
    try {
        instance.disconnect();
    } catch {
        /* noop */
    }
    instance = null;
    delete window.Echo;
}
